import { connect } from 'react-redux';

import { sendPageviewAction } from 'src/store/analytics/actions';
import { selectIsFetching } from 'src/store/popup/selectors';
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import {
  getOrderIsFinished,
  getSelectedFlightData,
} from '../../../../store/selectors/order';
import { getPath } from '../../../../store/selectors/router';
import Layout from './Layout';

import {
  getArchivedAt,
  getIsFuture,
  getIsManualPackage,
} from '../../../../store/selectors/package';
import { getSimilarPackagesHasAdjustParams } from '../../../../store/selectors/similar-packages';

import {
  routeTransitionEndAction,
  routeTransitionStartAction,
} from '../../../../store/actions/view';

const mapStateToProps = (state) => ({
  path: getPath(state),
  showLoader: selectIsFetching(state),
  isManualPackage: getIsManualPackage(state),
  isFinished: getOrderIsFinished(state),
  hasAdjustParams: getSimilarPackagesHasAdjustParams(state),
  selectedFlightsData: getSelectedFlightData(state),
  archivedAt: getArchivedAt(state),
  isFuture: getIsFuture(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  routeTransitionStart: routeTransitionStartAction,
  routeTransitionEnd: routeTransitionEndAction,
  sendPageview: sendPageviewAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
